import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { enTranslation } from '../locales/en';
import { heTranslation } from '../locales/he';
import { itTranslation } from '../locales/it';
import { esTranslation } from '../locales/es';
import { frTranslation } from '../locales/fr';
import { ruTranslation } from '../locales/ru';
import { i18nHotelConfig } from 'utils/hotel';
import { i18nConfig } from 'utils/ui';
import { i18nFlightConfig } from 'utils/flight/i18n';
import { i18nTransferConfig } from 'utils/transfer';
import { i18nPackageConfig } from 'utils/package';
import { i18nDynConfig } from 'utils/dynamic/i18n';

export const i18nconfig = () => {
  const lang = localStorage.getItem('language') || 'en';

  const defaultconfig = {
    enTranslation,
    heTranslation,
    itTranslation,
    esTranslation,
    frTranslation,
    ruTranslation,
  };
  i18nHotelConfig(defaultconfig);
  i18nDynConfig(defaultconfig);
  i18nFlightConfig(defaultconfig);
  i18nPackageConfig(defaultconfig);
  i18nTransferConfig(defaultconfig);
  i18nConfig(defaultconfig);

  i18n.use(initReactI18next).init({
    resources: {
      en: {
        translation: enTranslation,
      },
      he: {
        translation: heTranslation,
      },
      it: {
        translation: itTranslation,
      },
      es: {
        translation: esTranslation,
      },
      fr: {
        translation: frTranslation,
      },
      ru: {
        translation: ruTranslation,
      },
    },
    lng: lang ? lang : 'en',
    fallbackLng: 'en',

    interpolation: {
      escapeValue: false,
    },
  });
};

export default i18n;
